import { Select } from 'antd';
import { SelectProps } from 'antd/lib/select';
import React from 'react';
import { useQuery } from 'react-query';

import { getApplicableOfferPricingAttributeList } from '../../../services/pricing';

export type AttributeListProps = SelectProps<any> & {
  params: any;
  value?: number;
  onChange?: any;
  onClear?: () => void;
  disabled?: boolean;
  allowclear?: boolean;
};

const AttributeList = ({
  params,
  value,
  onChange,
  onClear,
  disabled,
  allowclear,
  ...otherProps
}: AttributeListProps) => {
  const { data: attributes, isFetching: isLoading } = useQuery(
    ['getApplicableOfferPricingAttributeList'],
    () =>
      getApplicableOfferPricingAttributeList({
        filters: params?.filtersList,
        objectid:
          params.offerid === 0 ? params?.pricing?.ofrid : params?.offerid, 
        objecttype: params.offerid !== 0 ? 'OFFER' : 'PRICING', 
      }).then((res) => res.list || [])
  );

  

  const handleChange: SelectProps<number>['onChange'] = (value) => {
    let attribute = attributes?.find((attribute)=>attribute.attid===value) 
    onChange && onChange(attribute);
  };

  return (
    <Select
      loading={isLoading}
      onChange={handleChange}
      allowClear
      onClear={onClear}
      {...otherProps}
    >
      {attributes?.map((attribute) => (
        <Select.Option value={attribute.attid} key={attribute.attid} title={attribute.attcomment}>
          {attribute.attlabel + ' ' + attribute.attexternalreference}
        </Select.Option>
      ))}
      {/* Add a check for undefined or null attributes */}
      {!attributes && (
        <Select.Option value={0} key="empty">
          No attributes found
        </Select.Option>
      )}
    </Select>
  );
};

export default AttributeList;
